import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { AdhocCheckbox } from './adhoc-checkbox.model';

@Injectable()
export class AdhocCheckboxService {
  constructor(private http: HttpClient) {}
}
